import {
  createAction,
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { IComplexesListState } from './interfaces';
import { deleteRequest, getRequest } from 'api/requests';
import { IComplex } from 'interfaces/main';
import { createComplex } from 'features/CreateComplexModal/CreateComplexModalSlice';

// Замена лота в списке
export const exchangeComplex = createAction(
  'complexesList/exchangeComplex',
  (complex: IComplex) => ({ payload: complex }),
);

// Загрузка списка организаций
export const fetchComplexes = createAsyncThunk(
  'complexesList/fetchComplexes',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { user } = getState() as RootState;

      const response = await getRequest(
        'complex',
        [5].includes(user.roleId)
          ? {}
          : { organizationId: user.organizationId },
        true,
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Удаление организации
export const removeComplex = createAsyncThunk(
  'complexesList/removeComplex',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await deleteRequest(`complex/${id}`, {}, true);

      return response.data.id;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Selectors
export const ComplexesListSelector = (state: RootState): IComplexesListState =>
  state.complexesList;

export const ComplexesListLoadingSelector = createSelector(
  ComplexesListSelector,
  ({ isLoading }) => isLoading,
);

export const ComplexesListItemsSelector = createSelector(
  ComplexesListSelector,
  ({ items }) => items,
);

const initialState: IComplexesListState = {
  isLoading: false,
  items: [],
};

const complexesListSlice = createSlice({
  name: 'complexesList',
  initialState,
  reducers: {
    exchangeComplex: (state, { payload }) => ({
      ...state,
      items: state.items.map((item: IComplex) =>
        item.id === payload.id ? payload : item,
      ),
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchComplexes.pending, (state) => ({
        ...state,
        isLoading: true,
      }))
      .addCase(fetchComplexes.rejected, (state) => ({
        ...state,
        isLoading: false,
      }))
      .addCase(fetchComplexes.fulfilled, (state, { payload }) => ({
        ...state,
        isLoading: false,
        items: payload.sort((a: IComplex, b: IComplex) => {
          if (a.title < b.title) {
            return -1;
          }
          if (a.title > b.title) {
            return 1;
          }
          return 0;
        }),
      }))
      .addCase(removeComplex.pending, (state) => ({
        ...state,
        isLoading: true,
      }))
      .addCase(removeComplex.rejected, (state) => ({
        ...state,
        isLoading: false,
      }))
      .addCase(removeComplex.fulfilled, (state, { payload }) => ({
        ...state,
        isLoading: false,
        items: state.items.filter((item: IComplex) => item.id !== payload),
      }))
      .addCase(createComplex.fulfilled, (state, { payload }) => ({
        ...state,
        isLoading: false,
        items: [...state.items, payload],
      }));
  },
});

export default complexesListSlice.reducer;
